export default {
  generic_error: 'Algo salió mal',
  address_not_found:
    'Lo sentimos, no encontramos esa dirección. Inténtalo de nuevo introduciendo primero la calle en el campo de búsqueda.',
  internal_error:
    'Lamentablemente, hubo un problema inesperado con tu pedido, nuestro equipo técnico ya está trabajando en ello 🛠️.',
};
